import { compose } from 'redux'
import { connect } from 'react-redux'
import { withProps } from 'recompose'
import TirePromotion from './TirePromotion'
import { formSelector } from '../TireCostForm/selectors'
import { TIRE_FRONT_INPUT_NAME, TIRE_REAR_INPUT_NAME } from 'constant'

const mapStateToProps = (state) => ({
  frontTireQuantity: formSelector(state, TIRE_FRONT_INPUT_NAME),
  rearTireQuantity: formSelector(state, TIRE_REAR_INPUT_NAME)
})

const withViewData = withProps(({
  frontTireQuantity,
  rearTireQuantity,
  frontTire: {
    listPrice: frontPricePerItem
  },
  rearTire: {
    listPrice: rearPricePerItem
  }
}) => {
  let totalPrice = 0
  if (frontPricePerItem && frontTireQuantity) {
    totalPrice = frontPricePerItem * frontTireQuantity
  }
  if (rearPricePerItem && rearTireQuantity) {
    totalPrice += rearPricePerItem * rearTireQuantity
  }
  return { totalPrice: totalPrice.toFixed(2) }
})


export default compose(
  connect(mapStateToProps, null),
  withViewData
)(TirePromotion)

